// extracted by mini-css-extract-plugin
export default {"nav_width_65":"Locations_nav_width_65__7j0Zi","ml_2":"Locations_ml_2__IsnB2"};